import React from "react"
import Showcase from "../components/Showcase"
import { Ads } from "react-ame-components"

export class AdsExample extends React.Component {
  render() {
    return (
      <Showcase
        centerGrid
        title="Componente Ads"
        description="Este componente exibe um anúncio. Caso não esteja mostrando nada, pode ser que o anúncio tenha sido removido.">
        <Ads
          path="/22158792083/MINIAPP_BANNERTEST/ad1"
          size={["fluid", [251, 260]]}
          id={"div-gpt-ad-1638211050548-0"}
        />
      </Showcase>
    )
  }
}
